module.exports = __webpack_public_path__ + "img/p2.45fffd2a.png";